import { Grid, Typography, Stack, Card } from "@mui/material";
import PropTypes from "prop-types";
import MuiBox from "@mui/material/Box";
import BackButton from "../../components/BackButton";

const Box = ({ rounded = true, children, transparent = true }) => (
  <MuiBox
    sx={{
      width: 40,
      height: 40,
      borderRadius: rounded ? 20 : 0,
      backgroundColor: transparent ? "transparent" : "primary.main",
      borderColor: "primary.dark",
      borderWidth: 2,
      borderStyle: "solid",
      color: transparent ? "primary.main" : "white"
    }}
  >
    <Stack justifyContent="center" alignItems="center" spacing={0}>
      {children}
    </Stack>
  </MuiBox>
);

Box.propTypes = {
  transparent: PropTypes.bool,
  rounded: PropTypes.bool,
  children: PropTypes.object
};

const Small = (props) => (
  <small style={{ marginTop: -4, fontSize: 10 }} {...props} />
);

const timers = [
  {
    title: "Round Fill",
    timer: () => (
      <Stack direction="row" spacing={1}>
        <Box transparent={false}>
          <Typography>00</Typography>
          <Small>days</Small>
        </Box>
        <Box transparent={false}>
          <Typography>22</Typography>
          <Small>hrs</Small>
        </Box>
        <Box transparent={false}>
          <Typography>23</Typography>
          <Small>mins</Small>
        </Box>
        <Box transparent={false}>
          <Typography>29</Typography>
          <Small>secs</Small>
        </Box>
      </Stack>
    )
  },
  {
    title: "Square Fill",
    timer: () => (
      <Stack direction="row" spacing={1}>
        <Box rounded={false} transparent={false}>
          <Typography>00</Typography>
          <Small>days</Small>
        </Box>
        <Box rounded={false} transparent={false}>
          <Typography>22</Typography>
          <Small>hrs</Small>
        </Box>
        <Box rounded={false} transparent={false}>
          <Typography>23</Typography>
          <Small>mins</Small>
        </Box>
        <Box rounded={false} transparent={false}>
          <Typography>29</Typography>
          <Small>secs</Small>
        </Box>
      </Stack>
    )
  },
  {
    title: "Highlight",
    timer: () => (
      <Stack
        direction="row"
        spacing={1 / 2}
        sx={{
          backgroundColor: "primary.main",
          borderWidth: 2,
          borderStyle: "solid",
          color: "white"
        }}
      >
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>00</Typography>
          <small>days</small>
        </Stack>
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>22</Typography>
          <small>hrs</small>
        </Stack>
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>23</Typography>
          <small>mins</small>
        </Stack>
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>29</Typography>
          <small>secs</small>
        </Stack>
      </Stack>
    )
  },
  {
    title: "Round Ghost",
    timer: () => (
      <Stack direction="row" spacing={1}>
        <Box>
          <Typography>00</Typography>
          <Small>days</Small>
        </Box>
        <Box>
          <Typography>22</Typography>
          <Small>hrs</Small>
        </Box>
        <Box>
          <Typography>23</Typography>
          <Small>mins</Small>
        </Box>
        <Box>
          <Typography>29</Typography>
          <Small>secs</Small>
        </Box>
      </Stack>
    )
  },
  {
    title: "Square Ghost",
    timer: () => (
      <Stack direction="row" spacing={1}>
        <Box rounded={false}>
          <Typography>00</Typography>
          <Small>days</Small>
        </Box>
        <Box rounded={false}>
          <Typography>22</Typography>
          <Small>hrs</Small>
        </Box>
        <Box rounded={false}>
          <Typography>23</Typography>
          <Small>mins</Small>
        </Box>
        <Box rounded={false}>
          <Typography>29</Typography>
          <Small>secs</Small>
        </Box>
      </Stack>
    )
  },
  {
    title: "Default",
    timer: () => (
      <Stack
        direction="row"
        spacing={0}
        divider={<>:</>}
        sx={{
          backgroundColor: "primary.main",
          borderWidth: 2,
          borderStyle: "solid",
          color: "white"
        }}
      >
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>00</Typography>
          <small>days</small>
        </Stack>
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>22</Typography>
          <small>hrs</small>
        </Stack>
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>23</Typography>
          <small>mins</small>
        </Stack>
        <Stack direction="row" alignItems="end" spacing={0}>
          <Typography>29</Typography>
          <small>secs</small>
        </Stack>
      </Stack>
    )
  }
];

export default function Timers() {
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <BackButton />
      <Typography variant="h3">Timer Integration</Typography>
      <Stack direction="row">
        <Typography mb={2} variant="body1">
          Choose below for Countdown Timer
        </Typography>
      </Stack>
      <Grid container spacing={2}>
        {timers.map((e) => (
          <Grid key={e.title} item xs={4}>
            <Card sx={{ p: 2, height: 240 }}>
              <Stack
                height="100%"
                justifyContent="center"
                alignItems="center"
                spacing={4}
              >
                <Typography>{e.title}</Typography>
                {e.timer()}
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
